import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: '[awairFormTitle]',
  templateUrl: './form-title.component.html',
  styleUrls: ['./form-title.component.scss']
})

export class FormTitleComponent implements OnInit {
  @HostBinding('style.font-size') hostFontSize: string = '20px';
  @Input()
  set fontSize(value: string) {
    if (value != null) {
      this.hostFontSize = value;
    }
  }

  constructor() {
  }

  ngOnInit() {
  }
}
